module.exports = __webpack_public_path__ + "73feeb50bc78018c72ab7b57f1707d15.pdf";